// Map list with image assets
// Note: Season-specific map pools are managed in seasons.js
const mapList = {
  snd: [
    { name: 'tunisia', image: '/assets/tunisia.jpg', thumbnail: '/assets/tuni.jpg' },
    { name: 'firing_range', image: '/assets/firingrange.jpg', thumbnail: '/assets/firing.jpg' },
    { name: 'meltdown', image: '/assets/map/Meltdown.jpg', thumbnail: '/assets/map/Meltdown_CODM.jpg' },
    { name: 'slums', image: '/assets/slums.jpg', thumbnail: '/assets/slum.jpg' },
    { name: 'coastal', image: '/assets/coastal.jpg', thumbnail: '/assets/coas.jpg' },
  ],
  hardpoint: [
    { name: 'summit', image: '/assets/summit.jpg', thumbnail: '/assets/summ.jpg'  },
    { name: 'takeoff', image: '/assets/takeoff.jpg', thumbnail: '/assets/tale.jpg'  },
    { name: 'hacienda', image: '/assets/hacienda.jpg', thumbnail: '/assets/haci.jpg' },
    { name: 'combine', image: '/assets/combine.jpg', thumbnail: '/assets/comb.jpg'  },
    { name: 'arsenal', image: '/assets/map/arsenal_map.png', thumbnail: '/assets/map/arsenal.png' },
  ],
  control: [
    { name: 'raid', image: '/assets/raid.jpg',  thumbnail: '/assets/rai.jpg' },
    { name: 'standoff', image: '/assets/standoff.jpg', thumbnail: '/assets/stand.jpg' },
    { name: 'crossroads', image: '/assets/map/crossroad.png', thumbnail: '/assets/map/Crossroads_CODM.jpg' },
  ],
};

// Helper to get map info by name
export const getMapInfo = (mapName, mode) => {
  if (!mapName || !mode) return null;
  
  const modeKey = mode.toLowerCase() === 'hp' ? 'hardpoint' : 
                  mode.toLowerCase() === 'snd' ? 'snd' : 
                  mode.toLowerCase() === 'ctl' ? 'control' : null;
  
  if (!modeKey || !mapList[modeKey]) return null;
  
  const normalizedName = mapName.toLowerCase().replace(/\s+/g, '_');
  return mapList[modeKey].find(map => 
    map.name.toLowerCase() === normalizedName || 
    map.name.toLowerCase() === mapName.toLowerCase()
  );
};

export default mapList;
